/**
 * Parse a value to boolean
 *
 * @param {*} - Value to parse
 * @return {Boolean} - Value parse to boolean
 */
const parseBoolean = value => {
  switch (value) {
    case true:
    case 'true':
    case 1:
    case '1':
      return true;
    default:
      return false;
  }
};

/**
 * Parse a value to string
 *
 * @param {*} - Value to parse
 * @return {String} - Value parse to string
 */
const parseString = value => {
  return String(value).trim();
};

/**
 * Parse a value to number
 *
 * @param {*} - Value to parse
 * @return {Number} - Value parse to string
 */
const parseNumber = value => {
  return Number(value);
};

/**
 * Comprueba que el valor se encuentra entre dos números,
 * en caso contrario redondea al límite más cercano
 *
 * @param {Number} value - Value to parse
 * @param {Number} min - Value to parse
 * @param {Number} max - Value to parse
 * @return {Number} - Value parse to string
 */
const parseBetween = (value, max, min) => {
  if (value < min) return min;
  if (value > max) return max;
  return value;
};

export { parseBoolean, parseString, parseNumber, parseBetween };
